import { createContext, useCallback, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import { countries } from '../data/demo';
import type { Country, CountryCode } from '../types';

interface CountryContextValue {
  country: Country;
  setCountryCode: (code: CountryCode) => void;
}

const CountryContext = createContext<CountryContextValue | undefined>(undefined);

export function CountryProvider({ children }: { children: ReactNode }) {
  const [code, setCode] = useState<CountryCode>(() => (localStorage.getItem('preferred-country') as CountryCode) || 'global');
  const country = useMemo(() => countries.find((item) => item.code === code) || countries[0], [code]);
  const setCountryCode = useCallback((next: CountryCode) => {
    setCode(next);
    localStorage.setItem('preferred-country', next);
    window.dispatchEvent(new CustomEvent('analytics', { detail: { event: 'country_selection', country: next } }));
  }, []);
  useEffect(() => { document.documentElement.dataset.country = code; }, [code]);
  return <CountryContext.Provider value={{ country, setCountryCode }}>{children}</CountryContext.Provider>;
}

export function useCountry() {
  const value = useContext(CountryContext);
  if (!value) throw new Error('useCountry must be used within CountryProvider');
  return value;
}
